<div class="litem">
    <div class="listitem-row" *ngFor="let listitem of listItems">
        <div class="litem-name">{{listitem.name}}</div>
        <div class="litem-description">{{listitem.description}}</div>        
        <div class="litem-action">
            <div class="litem-action-status" *ngIf="listitem.status == 2">
                <span style="color: green;font-weight: bold;font-size: larger;">Completed</span>
            </div>
            <div class="litem-action-status" *ngIf="listitem.status == 1">
                <span style="color: orange;;font-weight: bold;font-size: larger">Partially Completed</span>
            </div>
            <div class="litem-action-status" *ngIf="listitem.status == 0">
                <span style="color: red;;font-weight: bold;font-size: larger">Not Started</span>
            </div>
            <div class="litem-action-name">
                <a href="javascript:void(0);" (click)="actionclick(listitem)">{{listitem.action}}</a>
            </div>
            <div class="litem-action-icon">
                <img src="./assets/images/circle-arrow-right-solid.png" style="width: 18px" (click)="actionclick(listitem)"/>
            </div>
        </div>                
    </div>
</div>